const resetPageBlockingLoaderState = () => {
  const overlay = document.getElementById("overlay");
  const mainContainer = document.querySelector(".main-container");

  if (overlay) {
    overlay.style.display = "none";
  }

  mainContainer?.classList.remove("blur-background");
  document.body.style.overflow = "auto";
};

export const showLoader = () => {
  const loader = document.getElementById("loader");

  resetPageBlockingLoaderState();

  if (loader) {
    loader.style.display = "flex";
  }
};

export const hideLoader = () => {
  const loader = document.getElementById("loader");

  resetPageBlockingLoaderState();

  if (loader) {
    loader.style.display = "none";
  }
};
